"use client";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

const RenderMarkdownReadme = dynamic(() =>
  import("../../../../component/Markdown/Readme")
);

export default function ReadMe({ model }) {
  const [readme, setReadme] = useState("");

  useEffect(() => {
    fetch(
      `https://huggingface.co/${model.modelId}/resolve/main/README.md`
    ).then(async res => {
      let text = await res.text();

      if (text === "Entry not found") {
        res = await fetch(`https://huggingface.co/api/models/${model.modelId}`);

        const json = await res.json();
        const readme = json?.siblings?.find(file =>
          file.rfilename.toLowerCase().includes("readme.md")
        )?.rfilename;

        if (readme) {
          res = await fetch(
            `https://huggingface.co/${model.modelId}/resolve/main/${readme}`
          );
          text = await res.text();
        }

        if (text === "Entry not found") {
          text = "No readme was uploaded for this model";
        }
      }

      setReadme(text);
    });
  }, [model.modelId]);

  return readme ? (
    <RenderMarkdownReadme modelId={model.modelId} md={readme} />
  ) : null;
}
